module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner"
  }, [_c('nav', {
    staticClass: "inner__nav"
  }, [_c('ul', {
    staticClass: "inner__menu"
  }, _vm._l((_vm.menuLinks), function(ref, index) {
    var name = ref.name;
    var path = ref.path;
    var meta = ref.meta;

    return _c('router-link', {
      key: index,
      staticClass: "inner__item",
      attrs: {
        "tag": "li",
        "active-class": "",
        "exact-active-class": "",
        "to": {
          name: name
        }
      }
    }, [(_vm.$route.meta.title !== meta.title) ? _c('a', {
      staticClass: "inner__link",
      class: meta.menuColor ? ("inner__link_" + (meta.menuColor)) : ''
    }, [_vm._v(_vm._s(meta.title))]) : _c('span', {
      staticClass: "inner__link inner__link_active",
      class: meta.menuColor ? ("inner__link_" + (meta.menuColor)) : ''
    }, [_vm._v(_vm._s(meta.title))])])
  }), 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61c0faac","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/blocks/innermenu/InnerMenu.vue
// module id = 4bf088e4d0939d198885
// module chunks = 89